module.exports = __webpack_public_path__ + "static/media/icon--arrow.a587c921.svg";